import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { Spinner } from '../../ui/Spinner/Spinner';

/**
 * Shown in place of the whole app shell while useAcombaBridgeGate is running its up-front attempt (and
 * the one retry within its 10s window) — never let the shell render underneath with a bridge session
 * that isn't confirmed 'connected' yet (a half-connected bridge produced a greeting with no name and
 * downstream tenant-resolution issues).
 */
export const AcombaBridgeConnectingScreen: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div data-testid="acomba-bridge-connecting" className="flex min-h-screen items-center justify-center bg-surface">
            <div className="flex flex-col items-center gap-m">
                <Spinner className="w-6 h-6" sparks />
                <p className="text-s text-primary-700">{t(TranslationKey.AcombaBridge.Gate.Connecting)}</p>
            </div>
        </div>
    );
};
